import React from 'react';
import AutomowerConfig from '../components/AutomowerConfig';
import PageShell from '../components/design/PageShell';

const AdminAutomower = () => {
  return (
    <PageShell
      section="admin / automower"
      number="09.A"
      title="Automower"
      subtitle="Configuration OAuth Husqvarna · API v1"
    >
      <section className="ta-admin-frame" style={{ border: '1px solid var(--rule)', padding: 24, background: 'var(--bg-1)' }}>
        <AutomowerConfig />
      </section>

      <style>{`
        .ta-admin-frame .MuiPaper-root,
        .ta-admin-frame .MuiCard-root {
          background: var(--bg-elev) !important;
          color: var(--ink) !important;
          border: 1px solid var(--rule) !important;
          box-shadow: none !important;
        }
        .ta-admin-frame .MuiTypography-root { color: var(--ink) !important; }
        .ta-admin-frame .MuiInputBase-input { color: var(--ink) !important; }
        .ta-admin-frame .MuiInputLabel-root { color: var(--ink-3) !important; }
        .ta-admin-frame .MuiOutlinedInput-notchedOutline { border-color: var(--rule-2) !important; }
        .ta-admin-frame .MuiButton-root { color: var(--ink) !important; }
        .ta-admin-frame .MuiButton-contained { background: var(--accent) !important; color: var(--bg) !important; }
      `}</style>
    </PageShell>
  );
};

export default AdminAutomower;
